import { motion } from 'framer-motion';

interface MerchantStats {
  merchantName: string;
  visitCount: number;
  totalSpent: number;
}

interface RideOrDieBoxProps {
  merchantStats: MerchantStats;
}

export const RideOrDieBox = ({ merchantStats }: RideOrDieBoxProps) => {
  return (
    <div className="bg-white rounded-xl p-4 relative border-2 border-[#221A51] shadow-[4px_4px_0px_0px_#221A51]">
      <div className="flex justify-between items-center">
        <div>
          <div className="text-[#221A51]/60 text-sm mb-1">Ride or Die</div>
          <div className="text-[#221A51] text-lg font-bold">{merchantStats.merchantName}</div>
          <div className="text-[#221A51]/60 text-sm mt-1">{merchantStats.visitCount} visits</div>
        </div>
        <div className="text-base font-semibold text-[#221A51]">
          ${merchantStats.totalSpent.toLocaleString()}
        </div>
      </div>
    </div>
  );
};
